import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VendorProfile } from '@constants/global.enum';
import { GlobalErrorService } from '@services/global-error.service';
import { RoutesEnum, VendorListEnum } from '@app/shared/constants/global.enum';

@Component({
  selector: 'app-vendor-profile-page',
  templateUrl: './vendor-profile-page.component.html',
  styleUrls: ['./vendor-profile-page.component.scss'],
})
export class VendorProfileComponent implements OnInit {
  VendorProfile = VendorProfile;
  vendorId: string | null = null;
  vendorName: string | null = null;
  vendorList = VendorListEnum;

  constructor(
    private route: ActivatedRoute,
    private errorHandler: GlobalErrorService,
    private router: Router
  ) {}


  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.vendorId = params['vendorId'];
      this.vendorName = params['vendorName'] ? decodeURIComponent(params['vendorName']) : null;

      if (!this.vendorId) {
        this.errorHandler.showError(this.VendorProfile.vendorIdMissing);
        return;
      }

      if (!this.vendorName) {
        this.errorHandler.showError(this.VendorProfile.vendorNameMissing);
        return;
      }
    });
  }
   navigateToVendorDashboard(): void {
    this.router.navigate([`/${RoutesEnum.VendorManagement}`]);
  }
}
